import { makeStyles } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { Link } from 'react-router';

const useStyle = makeStyles((theme: any) => {
  return {
    link: {
      color: theme.palette.text.brand,
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.text.brandActive,
      },
    },
    buttonLink: {
      color: theme.palette.text.brand,
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.text.brandActive,
        textDecoration: 'none',
      },
    },
  };
});

const SesamLink: React.FC<{
  className?: string;
  to: string;
  buttonLink?: boolean;
  children: ReactNode;
  title?: string;
  testId?: string;
  tabIndex?: number;
  style?: React.CSSProperties;
  role?: string;
  activeClassName?: string;
}> = ({ className, to, buttonLink, title, testId, ...props }) => {
  const classes = useStyle();
  let fullClassName = buttonLink ? classes.buttonLink : classes.link;

  if (className) {
    fullClassName = fullClassName + ' ' + className;
  }

  return <Link className={fullClassName} to={to} title={title} data-testid={testId} {...props} />;
};

export default SesamLink;
